<template>
  <div class="produits-container">
    <div class="produits-title">
      <h1>NOS PRODUITS</h1>
      <div class="breadcrumb">
        <a href="/">Accueil</a> > <a href="/produits">Produits</a>
      </div>
    </div>
    
    <div class="produits-description">
      <h1>Produits de Laboratoire</h1>
      <p>
        Dans notre Société SupraCare, nous proposons une gamme diversifiée de produits de haute qualité conçus pour répondre aux besoins variés de la recherche scientifique
        et des expérimentations. Nos consommables sont fiables et fabriqués avec précision pour garantir des résultats cohérents. Les machines d’analyse que nous fournissons sont 
        des outils de pointe offrant une analyse précise pour diverses applications. Des spectrophotomètres aux systèmes de chromatographie, chaque instrument assure des données fiables
        pour des prises de décision éclairées. Nos produits chimiques respectent des normes de pureté strictes, garantissant des performances optimales dans les expériences. Toutes nos offres 
        sont accompagnées de certificats de haute qualité sur le marché, assurant leur fiabilité. Nous accordons une importance particulière à la satisfaction du client et visons à faciliter la recherche innovante.
      </p>
    </div>

    <!-- Ajout de la grille de catégories de produits -->
     <div class="container">
    <div class="produits-categories">
      <div class="category-card">
        <img src="@/assets/AKLIDES.png" alt="Équipement Labo">
        <a href="/equipementlabo">Équipement Labo</a>
      </div>
      <div class="category-card">
        <img src="@/assets/glove-latex.jpg" alt="Consommables">
        <a href="/consommables">Consommables</a>
      </div>
      <div class="category-card">
        <img src="@/assets/REACTIF-.jpg" alt="Réactifs">
        <a href="/reactifs">Réactifs</a>
      </div>
      <div class="category-card">
        <img src="@/assets/bact.jpg" alt="Bactériologie">
        <a href="/bacteriologie">Bactériologie</a>
      </div>
      <div class="category-card">
        <img src="@/assets/chimique.jpg" alt="Produits Chimiques">
        <a href="/chimiques">Produits Chimiques</a>
      </div>
       <div class="category-card">
        <img src="@/assets/vita.png" alt="Vitamines & Minéraux">
        <a href="/vitamines-mineraux">Vitamines & Minéraux</a>
      </div>
       <div class="category-card">
        <img src="@/assets/glucotest.png" alt="Glucotest">
        <a href="/glucotest">Glucotest</a>
      </div>
    </div>
  </div>
  </div>
</template>


<script>
export default {
  name: 'ProduitsI',
  
};
</script>

<style scoped>
/* Conteneur principal */
.produits-container {
  padding: 0;
  position: relative;
  background-size: cover;
  background-position: center;
  text-align: left;
  z-index: 1;
  overflow: hidden;
}

.produits-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: -1;
}

/* Titre des produits */
.produits-title {
   position: relative;
  background-image: url('C:/Users/PC MAROC/supracare_web/src/assets/img6.jpg');
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77);
  padding: 150px 300px;
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  z-index: 1;
}

/* Fil d'Ariane (breadcrumb) */
.breadcrumb {
  font-size: clamp(0.75rem, 2vw, 1rem);
  color: #514e4e;
  margin-top: 2px;
}

.breadcrumb a {
  color: #1d1343;
  text-decoration: none;
  font-weight: bold;
  font-size: 10px;
  
}

.breadcrumb a:hover {
  text-decoration: underline;
}

/* Description des produits */

.produits-description {
  
  padding: clamp(10px, 5vw, 50px) clamp(10px, 10vw, 200px);
  box-shadow: 0px 4px 15px rgba(71, 75, 193, 0.1);
  border-radius: 2px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
}

.produits-description p {
  font-size: clamp(1rem, 2.5vw, 1.2rem);
  margin: 20px 0;
  color: #333;
  line-height: 1.6;
   
}

/* Conteneur des catégories */
.produits-categories {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  padding: 1px;
  justify-items: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 50px; 
}

/* Cartes des catégories */
.container {
  padding-left: 30px;  /* Espace à gauche */
  padding-right: 30px; /* Espace à droite */
  display: flex;
  justify-content: center; /* Centre les cartes si elles sont moins larges que l'espace disponible */
  flex-direction: column;
}


.category-card {
  width: 250px; /* Largeur fixe pour toutes les cartes */
  height: 300px; /* Hauteur fixe pour toutes les cartes */
  text-align: center;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
}

/* Taille et style des images */
.category-card img {
  width: 100%;
  height: 70%; /* L'image occupe 70% de la carte */
  object-fit: cover; /* Pour garder les proportions */
}

/* Style des liens */
.category-card a {
  display: block;
  padding: 10px;
  background-color: #1d1343;
  color: white;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.category-card a:hover {
  background-color: #2a1b5b;
}

/* Animation au survol des cartes */
.category-card:hover {
  transform: translateY(-10px);
}

/* Responsive design pour plus petites tailles d'écran */
@media (max-width: 768px) {
  .produits-categories {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
  
  .category-card {
    width: 150px; /* Taille réduite pour mobile */
    height: 200px;
  }

  .category-card a {
    font-size: 14px;
  }
}

/* Responsive pour petites tailles d'écran */
@media (max-width: 1300px) {
  .produits-title {
    font-size: clamp(1.5rem, 5vw, 1rem);
   padding: 100px 0px;
  }

  .produits-description {
    padding: 20px;
  }

  .produits-description p {
    font-size: 1rem;
  }
}
  
</style>
